/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Metadata Type" |
*
* @param {Options_Metadata_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_type_label = /** @type {((inputs?: Options_Metadata_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de métadonnée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatentyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータタイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de metadados")
	return /** @type {LocalizedString} */ ("Metadata Type")
});